/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-07-09 12:04:24
 * @Description:
 */
import message from "./message/epn";
import placeholder from "./placeholder/epn";
let NODE_ENV = window.XINPOC_WEB_CONFIG.isProject;
let title = {
  globalpoc: "Globalpoc",
  hpyj: "Shenzhen Haopan Yijia Tecnología Co., Ltd.",
  EuroNews:"WOUXUN Global",
  quansheng:"QUESUM",
  yuantong:"pocptt",
  chunsheng:"poclink"
};
let conpanyname = {
    yuantong:"Quanzhou YANTON Electronics Co., Ltd."
}

let beian = {
    yuantong:"Website record number"
}

let icp = {
    yuantong:"Guangdong ICP No. 16086702"
}

let copyright = {
    yuantong:"Copyright © 2021-2022 Quanzhou YANTON Electronics Co., Ltd. Version: v1.7.2"
}
export default {
  language: {
    name: "中文",
    title: "Idioma",
  },
  about: {
    title: title[NODE_ENV] || "XIN POC",
    conpanyname: conpanyname[NODE_ENV] || "Schenzhen Broad Información Tecnología Co.LTD.",
    beian: beian[NODE_ENV] || "Número de registro del sitio web",
    icp: icp[NODE_ENV] || "Guangdong ICP No. 16086702",
    copyright: copyright[NODE_ENV] || "Schenzhen Broad Información Tecnología Co.LTD. Versión número: v2.1.8 Derecho de Autor 2021-2022",
  },
  login: {
    tag: {
      agent: "Agente",
      company: "Empresa",
    },

    placeholder: {
      account: "Por favor introduzca la cuenta de inicio de sesión",
      password: "Por favor introduzca la contraseña de inicio de sesión",
    },

    button: {
      login: "Iniciar sesión",
      remember: "Recordar el número de cuenta?",
    },

    tips: {
      empty: "La cuenta o la contraseña no pueden estar vacias",
      not_account: "La cuenta no existe",
      err_password: "Error de contraseña",
      completethepuzzle:
        "Arrastre el control deslizante hacia abajo para completar el rompecabezas",
      Verificationissuccessful: "La verificación es exitosa",
      Verificationerrorpleasetryagain:
        "Error de verificación inténtelo de nuevo",
    },
  },
  from: {
    //表单
    icon: "Avatar",
    Agent_name: "Nombre del agente",
    Account: "Cuenta de inicio de sesión",
    Contact_name: "Nombre del contacto",
    mobile: "Número de teléfono movil",
    uName: "Nombre",
    recharge_contact: "Información de contacto para la recarga",
    Select_Address: "Seleccionar dirección",
    Detailed_address: "Dirección detallada",
    Not_filled_in: "No rellenada",
    contact_information: "Información de contacto",
    area: "Area",
    Reset_Password: "Restablecer contraseña",
  },
  placeholder: {
    ...placeholder,
  },
  message: {
    //提示
    ...message,
  },
  but: {
    //按钮
    send_out: "Enviar",
    preserve: "Guardar",
    confirm: "Confirmar",
    define: "Aceptar",
    next: "Siguiente",
  },

  agent: {
    Agency_account: "Cuenta de la agencia",
    Contact_information: "Información de contacto",
    Please_enter_agentname: "Introduzca el nombre del agente",
    agentname_required: "(Obligatorio: 4-20 caracteres, letras, números)",
    Please_enter_loginAccount: "Introduzca la cuenta de inicio de sesión",
    loginAccount_required: "(Obligatorio: 6-20 letras, números)",
    Please_enter_loginPassword: "Introduzca la cuenta de inicio de sesión",
    loginPassword_required: "(Obligatorio: 6-16 letras, números)",
    Please_enter_contactname: "Introduzca el nombre del contacto",
    contactname_required: "(Obligatorio: 2-20 caracteres, letras, números)",
    Please_enter_address: "Introduzca la dirección detallada del agente",
    address_optional: "(Opcional)",
    search_agent: "Buscar agente",
    recover_integer:
      "El número de tarjetas de servicio recuperadas debe ser un número entero",
    recover_num: "El número de recuperación debe ser mayor que 0",
  },

  navigation: {
    personal_center: "Centro personal",
    search: "Buscar",
    my_agent: "Mi agente",
    agent_list: "Lista de agentes",
    create_agent: "Crear agente",

    my_company: "Mi empresa",
    company_list: "Lista de empresas",
    create_company: "Crear empresa",

    my_group: "Mi grupo",
    group_list: "Lista de grupos",
    create_group: "Crear grupo",

    my_user: "Mi usuario",
    user_list: "Lista de usuarios",
    create_user: "Crear usuario",

    news_notice: "Notificación de noticias",
    Scanning_code_found: "Escaneado para crear",

    function_card_sell: "Ventas de tarjetas de servicio",
    function_card_record: "Registro de tarjetas de servicio",
    system_annoucement: "Anuncio del sistema",

    my_bounding: "Mi valla",
    bounding_list: "Lista de delimitadores",
    create_bounding: "Crear una cerca",

    recording_record: "Registro de grabación",
    sos_record: "SOS récord",
    broadcast_record: "Registro de transmisión",
    Agent_details: "Detalles del agente",
    Scancodetocreate: "Escánear código para crear",
    Createuserinformation: "Crear información de usuario",
    Confirmdetails: "Confirmar detalles",
    EditOrganizationInformation: "Editar información de la empresa",
    notificationreminder: "Recordatorio de notificación",
    selectgroup: "Seleccionar grupo",
    edituserinformation: "Editar información del usuario",
    Userreplacementcard: "Tarjeta de reemplazo de usuario",
    completematerial: "Completar el material",
    choosehost: "Elija solo un altavoz (los demás se silencian)",
    Selectagrouptolistento: "Seleccionar un grupo para escuchar",
    Terminalrenewaldetails: "Detalles de renovación del terminal",
    managementplatform: "Plataforma de administración",
    electricfence: "Cerca electrónica",
    Electronicfencerecords: "Registros de cerca electrónica",
    Registeraccount: "Registrar cuenta",
    Boundcompanyusers: "Usuario vinculado",
    Unboundcompanyusers: "Usuario no vinculado",
    Listofboundcompanyusers: "Usuario de unidad vinculada",
    Listofunboundcompanyusers: "Usuario de unidad no vinculada",
  },

  setup: {
    setup: "Configuración",
    Change_Password: "Cambiar contraseña",
    user_information: "Información personal",
    Reset_Login_Password: "Restablecer contraseña de inicio de sesión",
    Modify_payment_password: "Modificar contraseña de pago",
    about: "Acerca de",
    Problem_feedback: "Comentarios sobre el problema",
    Verify_phone: "Verificar el teléfono",
    Set_payment_password: "Establecer contraseña de pago",
  },

  org: {
    org_name: "Nombre de la empresa",
    createCompany: "Nueva empresa",
    UnitAccount: "Cuentas de la empresa",
    createGroups: "Crear 16 grupos al mismo tiempo",
    plGroups: "Grupo de lotes: sufijo del nombre más número natural nombre re",
  },
  consume: "Consumir",
  area: "Area",
  logout: "Cerrar sesión",
  VerifyPC: "Abrir enlace en PC",
  // connect: 'Excepción de conexión al servidor',
  connect: "Cargando...",
  existing: "Existente",
  individual: "Uno",
  Quantityis: "La cantidad es 0 y no se puede recuperar",
  Withdrawal_quantity:
    "La cantidad retirada no puede ser mayor que la cantidad existente",
  click_load: "Haga clic para cargar mas",
  refresh_successfully: "Actualizado correctamente",
  search: "Buscar",
  detail: "Detalles",
  edit: "Editar",
  delete: "Eliminar",
  confirm: "Aceptar",
  cancel: "Cancelar",
  call_back: "Volver",
  time: "Hora",
  category: "Categoría",
  title: "Título",
  data: "Fecha",
  starting_date: "Fecha de inicio",
  ending_date: "Fecha de finalización",
  starting_time: "Periodo de inicio",
  ending_time: "Periodo de finalización",
  type: "Tipo",
  please_select: "Por favor seleccione",
  content: "Contenido",
  notice: "Aviso",
  tuneto_agent: "Sintonizar con el agente",
  beingTransferred_agent: "Agente transferido",
  thefence: "Valla",
  member: "Miembro",
  users: "Usuario",
  searchuser: "Buscar usuario",
  group: "Grupo",
  searchgroup: "Buscar grupo",
  company: "Empresa",
  searchunit: "Buscar empresa",
  agent_name: "Agente",
  prefixnickname: "Prefijo apodo",
  user_name: "Nombre de usuario",
  company_name: "Empresa afiliada",
  user_info: "Información del usuario",
  sale: "Venta",
  create_user: "Crear usuario",
  start_service: "Abrir servicio",
  recycle_recycled: "Reciclado/reciclado",
  delete_users: "Eliminar usuarios",
  deletequantity: "Eliminar cantidad",
  purchasement: "Compra",
  change_agents: "Cambiar agentes",
  voice: "Voz",
  recording: "Grabación",
  position: "Posicionamiento",
  thefence: "Valla",
  video: "Video",
  recycle: "Reciclar",
  recycled: "Reciclado",
  card_type: "Tipo de tarjeta de servicio",
  card_type1: "Tipo de tarjeta de servicio",
  select_card_type: "Seleccionar el tipo de tarjeta de servicio",
  card_number: "Número de tarjeta de servicio",
  ptt_card: "Tarjeta de voz",
  recording_card: "Tarjeta de grabación",
  gps_card: "Tarjeta de ubicación",
  sos_card: "Tarjeta SOS",
  bounding_card: "Tarjeta delimitadora",
  video_card: "Tarjeta de video",
  duplex_card: "Tarjeta duplex",
  vipcard: "Tarjeta VIP",
  ptt_card_sale: "Venta de tarjetas de voz",
  recording_card_sale: "Vente de tarjetas de grabación",
  gps_card_sale: "Vente de tarjetas de ubicación",
  sos_card_sale: "Venta de tarjetas SOS",
  bounding_card_sale: "Venta de tarjetas delimitadoras",
  video_card_sale: "Venta de tarjetas de video",
  Duplexcardsales: "Venta de tarjetas duplex",
  vipcardsales: "Venta de tarjetas VIP",
  pttgpssales: "Ventas de PTT+GPS",
  usevoicecard: "Usar tarjeta de voz",
  userecordingcard: "Usar tarjeta de grabación",
  uselocatorcard: "Usar tarjeta de localización",
  useSOScard: "Usar tarjeta SOS",
  usefencecard: "Usar tarjeta de valla",
  usevideocard: "Usar tarjeta de video",
  Useaduplexcard: "Usar una tarjeta duplex",
  usepttgps: "Uso de PTT+GPS",
  usevipcard: " Usar tarjeta VIP",
  voiceservicecard: "Tarjeta de servicio de voz",
  recordingservicecard: "Tarjetas de servicio de grabación",
  locationservicecard: "Tarjeta de servicio de ubicación",
  SOSservicecard: "Tarjeta de servicio SOS",
  fenceservicecard: "Tarjeta de servicio de valla",
  videoservicecard: "Tarjeta de servicio de video",
  Dualservicecard: "Tarjeta de servicio dual",
  vipservicecard: "Tarjeta de servicio VIP",
  voiceservice: "Voz",
  recordingservice: "Servicio de grabación",
  locationservice: "Servicio de ubicación",
  SOSservice: "Servicio SOS",
  fenceservice: "Servicio de valla",
  videoservice: "Servicio de video",
  duplexservice: "Servicio duplex",
  recordingcardrecycling: "Reciclaje de tarjetas de grabación",
  LocationCardRecycling: "Reciclaje de tarjetas de ubicación",
  SOSCardRecycling: "Reciclaje de tarjetas SOS",
  FenceCardRecycling: "Reciclaje de tarjetas de valla",
  videocardrecycling: "Reciclaje de tarjetas de video",
  Duplexcardrecycling: "Reciclaje de tarjetas duplex",
  VoiceFeatureNotification: "Notificación de función de voz",
  Notificationofrecordingfunction: "Notificacion de la función de grabación",
  Positioningfeaturenotification:
    "Notificación de la función de posicionamiento",
  SOSfunctionnotification: "Notificación de la función SOS",
  Fencefeaturenotification: "Notificación de la función de valla",
  VideoFeatureNotification: "Notificación de función video",
  DuplexFeatureNotification: "Notificación de función dúplex",
  PTTGPSFeatureNotification: "Notificaciones de la función PTT+GPS",
  automatically:
    "Eliminar automáticamente las notificaciones de usuario de prueba",
  DeleteExpired: "Eliminar la notificación de usuario caducada",
  remained: "Salido",
  pieces: "Pieza",
  residue: "Residual",
  recycle_successfully: "Reciclar correctamente",
  None_record: "Sin registro todavía",
  this_month: "Este mes",
  Year: "Ano",
  moon: "mes",
  day: "Día",
  weekly1: "Lunes",
  weekly2: "Martes",
  weekly3: "Miércoles",
  weekly4: "Jueves",
  weekly5: "Viernes",
  weekly6: "Sábado",
  weekly7: "Domingo",
  submit: "Enviar",
  modify_successfully: "Modificado correctamente",
  confirm1: "Confirmar",
  lumpsum: "Total",
  selltoagents: "Vender a agentes",
  nametips:
    "El apodo ingresado es solo el prefijo del apodo del usuario y el sufijo se distingue por un número natural según la cantidad de usuarios que creó. Por ejemplo: el apodo que ingresó es",
  nametips2: "Los apodos de los dos usuarios que creó son",
  nametips3: "La próxima vez",
  nametips4: "Para el apodo con prefijo el nombre de usuario se extenderá a",
  nametips5: "Espere",
  IMEIscancodetoadd: "Código de escaneo IMEI para agregar",
  IMEIinputadded: "Entrada de IMEI agregada",
  IMEIinputaddedtocreate:
    "Entrada de IMEI agregada para crear hasta 10 usuarios",
  Starttherecordingservice: "Iniciar el servicio de grabación",
  Turnonlocationservices: "Activar los servicios de ubicación",
  EnableSOSservice: "Habilitar el servicio SOS",
  Startfenceservice: "Iniciar el servicio de valla",
  Turnondualservice: "Activar el servicio dual",
  Turnonthevideoservice: "Activar el servicio de video",
  EnablePTTservice: "Activar servicio PTT",
  EnableVIPservice: "Activar servicio VIP",
  PTTGPSService:"Servicio de voz + ubicación",
  Usercomments: "Comentarios del usuario",
  Agentnote: "Nota del agente",
  total: "Total",
  settlement: "Liquidación",
  hint: "Pista",
  Areyousuretoremove: "Está seguro de eliminar?",
  Areyousuretoclearall: "Esta seguro de borrar todo?",
  cocreated: "Co-creado",
  accountssubtotal: "Subtotal de cuentas",
  Scancodeentryarea: "Área de entrada de código de escaneo",
  empty: "Vacio",
  none: "Ninguno",
  Second: "Segundos",
  Salesvolume: "Volumen de ventas",
  Purchasequantity: "Cantidad de compra",
  returnquantity: "Cantidad devuelta",
  Recoveredquantity: "Cantidad recuperada",
  returnquantity2: "Cantidad devuelta",
  setasdefaultgroup: "Establecer como grupo predeterminado",
  newgroup: "Nuevo grupo",
  groupname: "Nombre del grupo",
  selected: "Seleccionado",
  groups: "Grupos",
  allgroups: "Todos los grupos",
  Groupduration: "Duración del grupo",
  calltime: "Tiempo de llamada",
  groupmembers: "Miembros del grupo",
  Modifygroupname: "Modificar el nombre del grupo",
  priority: "Prioridad",
  remove: "Eliminar",
  addmembers: "Añadir miembros",
  levelone: "Nivel 1",
  Secondary: "Nivel 2",
  Levelthree: "Nivel 3",
  Levelfour: "Nivel 4",
  Fifthgrade: "Nivel 5",
  OKtoadd: "Aceptar para añadir",
  reenter: "Volver a introducir",
  Setdigitservicecardpassword:
    "Establecer la contraseña de la tarjeta de servicio de 6 dígitos",
  Enteragaintoconfirm: "Volver a introducir para confirmar",
  Enterthedigitservicecardpassword:
    "Introducir la contraseña de la tarjeta de servicio de 6 dígitos",
  consumptioncard: "Tarjeta de consumo",
  ConsumeSOScard: "Tarjeta SOS de consumo",
  Consumefencecard: "Tarjeta de protección de consumo",
  Consumptionrecordingcard: "Tarjeta de registro de consumo",
  Consumeduplexcard: "Tarjeta duplex de consumo",
  Consumptionvideocard: "Tarjeta de video de consumo",
  account: "Cuenta",
  unfilled: "Sin rellenar",
  contactnumber: "Número de contacto",
  emailaddress: "Dirección de correo electrónico",
  mailingaddress: "Dirección postal",
  Belonginggroup: "Grupo de pertenencia",
  Nickname: "Nombre de usuario",
  suspendaccount: "Cuenta",
  unitdispatcher: "Despachador de la empresa",
  dispatcher: "Despachador",
  basestationpositioning: "Posicionamiento de la estación base",
  GPSlocation: "Ubicación GPS",
  positioninginterval: "Intervalo de posicionamiento",
  videocall: "Videollamada",
  strongpullvideo: "Video de fuerte atracción",
  videoreturn: "Devolución del video",
  Numberchangeperiod: "Periodo de cambio de número",
  UsersNickname: "Periodo de cambio de número",
  volumeactivation: "Activación por letras",
  batchselection: "Selección por lotes",
  searchhistory: "Historial de búsquedas",
  returnnotice: "Notificación de devolución",
  Notificationofbeingwithdrawn: "Notificación de retirada",
  takebacknotice: "Adviso de devolución",
  bouncenotification: "Notificación de rebote",
  Notificationofbeingreturned: "Notificación de devolución",
  Createusernotification: "Crear notificación de usuario",
  purchasenotice: "Notificación de compra",
  salereminder: "Recordatorio de venta",
  today: "Hoy",
  yesterday: "Ayer",
  thedaybeforeyesterday: "Anteayer",
  OriginalIMEI: "IMEI original",
  NewIMEI: "Nuevo IMEI",
  replace: "Reemplazar",
  verificationcode: "Código de verificación",
  resendverificationcode: "Reenviar el código de verificación",
  back: "Atrás",
  host: "Sólo un altovoz (los demás se silencian)",
  listeninggroup: "Grupo de escucha",
  Addlisteninggroup: "Añadir grupo de escucha",
  Nodata: "Sin datos",
  Corenewal: "Tarifa total de renovación",
  Accountssubtotal: "Subtotal de cuentas",
  Confirmrenewal: "Confirmar renovación",
  add_groupname_tips:
    "Agregué un número natural al sufijo del nombre del grupo de lotes y continué con el número natural para los nombres repetidos.",
  Dataloadingcomplete: "Carga de datos completa",
  Usercreatedgroups: "Grupos creados por el usuario",
  Lord: "Linder del grupo",
  chooseagroupleader: "Elegir un linder de grupo",
  alluser: "Todos los usuarios",
  SOSalarmsintemporarygroupsarenotrecorded:
    "Las alarmas SOS en grupos temporales no se registran.",
  username: "Nombre de usuario",
  startingtime: "Hora de inicio",
  Processor: "Procesador",
  processtime: "Tiempo de procesamiento",
  Unprocessed: "Sin procesar",
  Processed: "Procesado",
  deleted: "Eliminado",
  name: "Nombre",
  address: "Dirección",
  Warmreminder:
    "Recordatorio: Los datos provienen de un tercero y pueden contener errores. Son solo de referencia.",
  SOSlocation: "Ubicación SOS",
  permanent: "Permanente",
  Latitudeandlongitude: "Latitud y Longitud",
  Reportingtime: "Hora del informe",
  Positioningtime: "Tiempo de posicionamiento",
  op1: "Encendido",
  op2: "Apagado",
  groupban: "Prohibición de grupo",
  setptt: "Establecer periodo de servicio PTT",
  Determinethemodification: "Determinar la modificación",
  Onemonth: "Un mes",
  Threemonths: "Tres meses",
  Halfayear: "Medio año",
  Expiredate: "Fecha de vencimiento",
  year1: "Un año",
  year2: "Dos años",
  year3: "Tres años",
  Sun: "Domingo",
  Mon: "Lunes",
  Tue: "Martes",
  Wed: "Miércoles",
  Thu: "Jueves",
  Fri: "Viernes",
  Sat: "Sábado",
  Membermanagement: "Gestión de miembros",
  Validpermanently: "Válido permanentemente",
  Enteralarm: "Entrar alarma",
  Leavealarm: "Salir alarma",
  repeat: "Repetir",
  Updatefence: "Actualizar valla",
  Triggermode: "Modo de activación",
  Validperiod: "Periodo válido",
  start: "Inicio",
  end: "Fin",
  Validdate: "Fecha válida",
  fencekeeper: "Cuidador de la valla",
  Membermanagement: "Gestión de miembros",
  fencename: "Nombre de la valla",
  Editfence: "Editar valla",
  Setupafencemanager: "Configurar un administrador de valla",
  Fencedetails: "Detalles de la valla",
  Currentoutofboundsrecord: "Registro actual de fuera de límites",
  Historicalcrossborderrecords: "Registros históricos transfronterizos",
  Allfences: "Todos las vallas",
  Triggertime: "Hora de activa",
  Releasetime: "Hora de liberación",
  NoExit: "Sin salida",
  NoEntry: "Sin entrada",
  Recordinglist: "Lista de grabación",
  temporarygroup: "Grupo temporal",
  Voicelicensetype: "Tipo de licencia de voz",
  Voicelicensetime: "Hora de la licencia de voz",
  UTCtimeTips: "La hora de vencimiento es la hora UTC",
  Determinethereplacement: "Determinar el reemplazo",
  Regionalreplacement: "Reemplazo regional",
  Recoverypassword: "Contraseña de recuperación",
  usertype: "Tipo de usuario",
  Singlefunctioncarduser: "Usuario de tarjeta de función única",
  vipcarduser: "Usuario de tarjeta VIP",
  PTTGPS: "PTT+GPS",
  PTTGPSuser: "Usuarios de PTT+GPS",
  display: "Mostrar nombre de usuario",
  Service_card_display: "Visualización de la tarjeta de servicio",
  RequiredvoiceserviceorVIPservice: "Servicio PTT requerido o servicio VIP",
  is_card: {
    ptt: "PTT",
    recording: "Grabación",
    gps: "GPS",
    sos: "SOS",
    bounding: "Delimitación",
    duplex: "Duplex",
    vip: "VIP",
  },
  Dispatcherrole: "Rol de despachador",
  ServiceTimeDisplay:'Mostrar Información del Servicio',
  show: "Mostrar",
  point: "Llamada punto a punto",
  IMEIchange: "Cambio IMEI",
  Register: "Registrar",
  Bindingdevice: "Vinculación de dispositivo",
  Notactivated: "No activado",
  Platformcreation: "Creación de plataforma",
  Userregistration: "Registro de usuario",
  Binding: "Vinculación",
  Notenabled: "No habilitado",
  Unbinding: "Desvinculando",
  userPatrol: {
    PatrolCard: "Tarjeta de patrulla",
    Patrol: "Patrulla",
    DisplayPatrolCard: "Tarjeta de patrulla de exhibición",
    GuardCardRecycling: "reciclaje de tarjetas de protección",
    patrolService: "servicio de patrulla",
    ConsumePatrolCards: "Consumir tarjetas de patrulla",
    StartPatrolService: "Servicio de patrulla de inicio",
    YourPatrolCardIsInsufficientPleaseRecharge:
      "Su tarjeta de patrulla no tiene saldo suficiente, ¡recárguela!",
    UsingPatrolCards: "Utilizando tarjetas de patrulla",
    PatrolCardBalanceInsufficient:
      "Saldo insuficiente en la tarjeta de patrulla",
    PatrolServiceCard: "Tarjeta de servicio de patrulla",
    PatrolCardSales: "Venta de tarjetas de patrulla",
    PatrolFunctionNotification: "Notificación de función de patrulla",
    PatrolManagement: "Gestión de patrullas",
    PatrolPlan: "Plan de patrulla",
    ExecuteTheTask: "Ejecutar la tarea",
    PatrolReport: "Informe de patrulla",
    SearchPlan: "Plan de búsqueda",
    Suspended: "Suspendido",
    Enabled: "Activado",
    NewPlans: "Nuevos planes",
    TerminalReminderSettings: "Configuración de recordatorio de terminal",
    ReminderRules: "Reglas de recordatorio",
    ReminderTime: "Hora del recordatorio",
    NumberOfReminders: "Número de recordatorios",
    minute: "minuto",
    note1:
      "Nota:Si la hora de recordatorio de inicio de patrulla está configurada para30Minutos, recordando a los usuarios2La próxima vez. Entonces, los usuarios que participen en la patrulla...30Recibido el primer minuto1Se enviará un recordatorio antes del inicio.15Recibido el primer minuto2Se contabilizará el número de notificaciones de mensajes, y así sucesivamente.",
    PleaseEnterTheReminderTime:
      "Por favor, introduzca la hora del recordatorio.",
    PleaseEnterTheNumberOfReminders:
      "Por favor, introduzca el número de recordatorios.",
    PleaseEnterANumberGreaterThanOrEqualTo20:
      "Por favor, introduzca un número mayor o igual a 20.",
    PleaseEnterANumberLessThanOrEqualTo5:
      "Por favor, introduzca un número menor o igual a 5.",
    OperationSuccessful: "Operación exitosa",
    NewPatrolPlan: "Nuevo plan de patrullaje",
    PleaseEnterThePlanName: "Por favor, introduzca el nombre del plan.",
    UsersWhoNeedPatrols: "Usuarios que necesitan patrullas",
    OnlyRegularUsersWhoHaveActivatedThePatrolServiceCanPerformPatrols:
      "Solo los usuarios habituales que hayan activado el servicio de patrulla pueden realizar patrullas.",
    EffectiveDateOfThePlan: "Fecha de entrada en vigor del plan",
    PlannedStatus: "Estado planificado",
    Week: "Semana",
    DailyPatrolTime: "Hora de patrulla diaria",
    TaskGenerationTime: "Tiempo de generación de tareas",
    AutomaticallyGenerateTheTimeForTheNextDaysScheduledTasksEveryDay:
      "Genera automáticamente el tiempo para las tareas programadas del día siguiente cada día.",
    patrolPoint: "punto de patrulla",
    save: "ahorrar",
    TheProjectNameAlreadyExists: "El nombre del proyecto ya existe.",
    TheNameConsistsOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "El nombre consta de entre 1 y 50 caracteres, incluyendo caracteres chinos, números, letras y símbolos especiales.",
    PleaseSelectTheUserWhoNeedsToBePatrolled:
      "Seleccione el usuario que necesita ser vigilado.",
    PleaseSelectTheEffectiveDateOfThePlan:
      "Seleccione la fecha de entrada en vigor del plan.",
    PleaseSelectDailyPatrolTime:
      "Por favor, seleccione la hora de patrulla diaria.",
    TheEndTimeMustBeGreaterThanTheStartTime:
      "La hora de finalización debe ser posterior a la hora de inicio.",
    PleaseSelectTheTaskGenerationTimeForTheNextDay:
      "Por favor, seleccione la hora de generación de tareas para el día siguiente.",
    PleaseAddPatrolPoints: "Por favor, añada puntos de patrulla.",
    PatrolUsers: "Usuarios de patrulla",
    AddUser: "Agregar usuario",
    ConfirmAdd: "Confirmar Agregar",
    PleaseSelectTheUserYouWishToAdd: "Seleccione el usuario que desea agregar.",
    UserAddedSuccessfully: "Usuario agregado correctamente",
    AddTo: "añadir",
    PatrolPointNames: "Nombres de puntos de patrulla",
    PleaseEnterThePatrolPointName:
      "Introduzca el nombre del punto de patrulla.",
    RequiredTheNameMustConsistOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "(Requisito: El nombre debe constar de entre 1 y 50 caracteres, incluyendo caracteres chinos, números, letras y símbolos especiales).",
    NFCNumber: "número NFC",
    PleaseEnterYourNFCNumber: "Introduzca su número NFC.",
    Required150Characters: "(Requisito: 1-50 caracteres)",
    ThePatrolPointNameAlreadyExists:
      "El nombre del punto de patrulla ya existe.",
    TheNameConsistsOf150CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "El nombre consta de 1 a 50 caracteres, incluyendo caracteres chinos, números, letras y símbolos especiales.",
    Remark: "Observación",
    NoteWithin100Characters: "Nota: Máximo 100 caracteres",
    CreationSuccessful: "Creación exitosa",
    EditorsPatrolPoint: "Punto de patrulla del editor",
    save1: "ahorrar",
    ModificationSuccessful: "Modificación exitosa",
    delete: "borrar",
    Remove: "Eliminar",
    AreYouUreYouWantToDeleteThisPatrolPoint:
      "¿Estás seguro de que quieres eliminar este punto de patrulla?",
    DeletionSuccessful: "Eliminación exitosa",
    EditorsPatrolPlan: "Plan de patrulla del editor",
    PatrolPlanDetails: "Detalles del plan de patrulla",
    AreYouSureYouWantToSuspendThePlanIfSuspendedTodaysScheduledPatrolsWillBeCancelled:
      "¿Está seguro de que desea suspender el plan? Si se suspende, las patrullas programadas para hoy se cancelarán.",
    OperationSuccessful1: "Operación exitosa",
    PleaseSelectTime: "Por favor, seleccione la hora",
    FullPlan: "Plan completo",
    AllUsers: "Todos los usuarios",
    ProjectName: "Nombre del proyecto",
    PatrolUsers1: "Usuarios de patrulla",
    PatrolTime: "Tiempo de patrulla",
    NotStarted: "No ha comenzado",
    inProgress: "en curso",
    Completed: "Terminado",
    MissedInspection: "Inspección perdida",
    PleaseEnterYourUsername: "Por favor, introduzca su nombre de usuario.",
    ExecutionDetails: "Detalles de ejecución",
    PatrolPointNames1: "Nombres de puntos de patrulla",
    PatrolYype: "Tipo de patrulla",
    ExecutionResult: "Resultado de la ejecución",
    position: "posición",
    NFC: "NFC",
    Bluetooth: "Bluetooth",
    PleaseSelectPatrolUser: "Seleccione usuario de patrulla",
    DailyStatistics: "Estadísticas diarias",
    WeeklyStatistics: "Estadísticas semanales",
    MonthlyStatistics: "Estadísticas mensuales",
    time: "tiempo",
    NumberOfPlannedExecutions: "Número de ejecuciones planeadas",
    ActualNumberOfExecutions: "Número real de ejecuciones",
    NumberOfMissedInspections: "Número de inspecciones omitidas",
    CompletionRate: "Tasa de finalización",
    PleaseEnterYourUsername: "Por favor, introduzca su nombre de usuario.",
    Existing: "Existente",
    NewPatrolPoints: "Nuevos puntos de patrulla",
  },
  minute: "minuto",
  Reclaim: "Reclamar",
  TestUser: "Usuarios de prueba",
  test_t: "Prueba",
  Formal: "Formal",
  Testuserscannotactivatefeatureservices:
    "¡Los usuarios de prueba no pueden activar los servicios de funciones!",
};
